
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import styles from './AppBundle.module.css';

const BundleUpload = ({ apps, onBundleUploaded, onClose }) => {
    const [fileData, setFileData] = useState({
        file: null,
        fileName: '',
        fileSize: 0,
        fileType: '',
        lastModified: null,
        uploadStatus: 'idle',
        errorMessage: ''
    });

    const [bundleInfo, setBundleInfo] = useState({
        app_id: '',
        bundle_version: '',
        description: ''
    });

    const [dragOver, setDragOver] = useState(false);
    const fileInputRef = useRef(null);

    const handleFileSelection = (selectedFile) => {
        if (!selectedFile) {
            setFileData(prev => ({
                ...prev,
                errorMessage: 'No file selected'
            }));
            return;
        }

        if (!selectedFile.type.includes('zip') && !selectedFile.name.endsWith('.zip')) {
            setFileData(prev => ({
                ...prev,
                errorMessage: 'Please select a valid ZIP file',
                file: null,
                fileName: '',
                fileSize: 0,
                fileType: '',
                lastModified: null
            }));
            return;
        }

        const maxSize = 100 * 1024 * 1024;
        if (selectedFile.size > maxSize) {
            setFileData(prev => ({
                ...prev,
                errorMessage: 'File size must be less than 100MB',
                file: null,
                fileName: '',
                fileSize: 0,
                fileType: '',
                lastModified: null
            }));
            return;
        }

        setFileData({
            file: selectedFile,
            fileName: selectedFile.name,
            fileSize: selectedFile.size,
            fileType: selectedFile.type,
            lastModified: new Date(selectedFile.lastModified),
            uploadStatus: 'idle',
            errorMessage: ''
        });
    };

    const uploadHandler = (event) => {
        const selectedFile = event.target.files[0];
        handleFileSelection(selectedFile);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            handleFileSelection(files[0]);
        }
    };

    const handleFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleBundleInfoChange = (field, value) => {
        setBundleInfo(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const validateAllFields = () => {
        const errors = [];

        if (!apps) {
            errors.push('Please select an app');
        }
        if (!bundleInfo.bundle_version.trim()) {
            errors.push('Bundle version is required');
        }
        const versionRegex = /^\d+\.\d+\.\d+$/;
        if (!versionRegex.test(bundleInfo.bundle_version)) {
            errors.push('Bundle version should be in format: x.x.x (e.g., 1.0.0)');
        }
        if (!bundleInfo.description.trim()) {
            errors.push('Description is required');
        }
        if (!fileData.file) {
            errors.push('Please select a file first');
        }

        return errors;
    };

    const upload = async () => {
        const validationErrors = validateAllFields();

        if (validationErrors.length > 0) {
            setFileData(prev => ({
                ...prev,
                errorMessage: validationErrors.join('. '),
                uploadStatus: 'error'
            }));
            return;
        }

        try {
            setFileData(prev => ({
                ...prev,
                uploadStatus: 'uploading',
                errorMessage: ''
            }));

            // const selectedApp = apps.find(app => app.app_id === parseInt(bundleInfo.app_id));
            const selectedApp = apps

            console.log('selected app :',selectedApp)

            const formData = new FormData();
            formData.append('bundle', fileData.file);
            // formData.append('app_info', JSON.stringify(selectedApp));
            // formData.append('app_name', selectedApp.app_name);
            // formData.append('app_version', selectedApp.current_version || '1.0.0');
            formData.append('bundle_version', bundleInfo.bundle_version.trim());
            // formData.append('description', bundleInfo.description.trim());
            formData.append('app_id', selectedApp.app_id);
            formData.append('bundle_name', fileData.fileName);
            formData.append('bundle_size', fileData.fileSize);
            formData.append('mime_type', fileData.fileType);
            formData.append('uploadTimestamp', new Date().toISOString());


            console.log('formdata : ',formData)

            const url = `${process.env.REACT_APP_URL}`;
            const response = await axios.post(`${url}/auth/uploadAppBundle`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log(response.data, "upload response");

            if (onBundleUploaded) {
                onBundleUploaded();
            }

            setFileData(prev => ({
                ...prev,
                uploadStatus: 'success',
                errorMessage: ''
            }));

            setTimeout(() => {
                onClose();
            }, 2000);

        } catch (error) {
            console.log("Error uploading file:", error);
            setFileData(prev => ({
                ...prev,
                uploadStatus: 'error',
                errorMessage: error.response?.data?.message || 'Upload failed. Please try again.'
            }));
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Upload App Bundle</h3>
                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.formGrid}>
                    {/* <div className={styles.formGroup}>
                        <label className={styles.label}>
                            Select App *
                        </label>
                        <select
                            value={bundleInfo.app_id}
                            onChange={(e) => handleBundleInfoChange('app_id', e.target.value)}
                            className={styles.input}
                        >
                            <option value="">Choose an app</option>
                            {apps.map(app => (
                                <option key={app.app_id} value={app.app_id}>
                                    {app.app_name} (ID: {app.app_id})
                                </option>
                            ))}
                        </select>
                    </div> */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>
                            Bundle Version *
                        </label>
                        <input
                            type="text"
                            value={bundleInfo.bundle_version}
                            onChange={(e) => handleBundleInfoChange('bundle_version', e.target.value)}
                            placeholder="e.g., 1.0.0"
                            className={styles.input}
                        />
                    </div>
                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                        <label className={styles.label}>
                            Description *
                        </label>
                        <textarea
                            value={bundleInfo.description}
                            onChange={(e) => handleBundleInfoChange('description', e.target.value)}
                            placeholder="Enter bundle description"
                            rows="3"
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        App Bundle File *
                    </label>
                    <div
                        className={`${styles.fileUploadArea} ${dragOver ? styles.dragOver : ''}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleFileClick}
                    >
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".zip,application/zip"
                            onChange={uploadHandler}
                            className={styles.fileInput}
                            style={{ display: 'none' }}
                        />
                        <div className={styles.fileUploadText}>
                            {fileData.fileName ? (
                                <div>
                                    <p>File selected: {fileData.fileName}</p>
                                    <p>Click to choose a different file</p>
                                </div>
                            ) : (
                                <div>
                                    <p>Drag & drop your ZIP file here</p>
                                    <p>or click to browse</p>
                                </div>
                            )}
                        </div>
                        <button className={styles.fileUploadButton}>
                            Choose File
                        </button>
                    </div>
                    <p className={styles.fileInfo}>
                        Only ZIP files are allowed. Maximum size: 100MB
                    </p>
                </div>

                {fileData.fileName && (
                    <div className={styles.fileDetails}>
                        <h4 className={styles.fileDetailsHeading}>Selected File Details</h4>
                        <p><strong>Name:</strong> {fileData.fileName}</p>
                        <p><strong>Size:</strong> {formatFileSize(fileData.fileSize)}</p>
                        <p><strong>Type:</strong> {fileData.fileType || 'application/zip'}</p>
                        <p><strong>Last Modified:</strong> {fileData.lastModified?.toLocaleString()}</p>
                    </div>
                )}

                {fileData.errorMessage && (
                    <div className={styles.errorMessage}>
                        {fileData.errorMessage}
                    </div>
                )}

                {fileData.uploadStatus === 'uploading' && (
                    <div className={styles.uploadStatus}>
                        Uploading...
                    </div>
                )}

                {fileData.uploadStatus === 'success' && (
                    <div className={styles.successMessage}>
                        File uploaded successfully!
                    </div>
                )}

                <div className={styles.modalActions}>
                    <button
                        onClick={onClose}
                        className={styles.secondaryButton}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={upload}
                        disabled={fileData.uploadStatus === 'uploading'}
                        className={styles.primaryButton}
                    >
                        {fileData.uploadStatus === 'uploading' ? 'Uploading...' : 'Upload Bundle'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BundleUpload;